import React, { Component } from "react";
import moment from "moment";
import {
  Button,
  FormGroup,
  // ControlLabel,
  FormControl,
  Row,
} from "react-bootstrap";

import _, { toInteger } from "lodash";
// import Loading from "../../components/Loading/Loading";
import withAuthorization from "../../components/Authorization/withAuthorization";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import Multiselect from "react-widgets/lib/Multiselect";
import RecipientsTable from "../GrantAccess/RecipientsTable";
import DateTime from "react-datetime";
import "react-widgets/dist/css/react-widgets.css";
import "../../assets/css/header.css";
import "../../routes/app";
import "../../../node_modules/react-datetime/css/react-datetime.css";
// import LocalizedStrings from "react-localization";
// let localizationStrings = new LocalizedStrings({

// })

class LockScheduling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locklistArray: [],
      selectedLock: null,
      userFriendListArray: [],
      selectedFriendsArray: [],
      selectedRecipients: [],
      selectedStartTime: 0,
      selectedEndTime: 0,
      selectedTimeRollover: false,
      invalidMemberLimit: null,
      showTable: false,
      loading: true,

      //for buttons
      dayButtonStyling: "schedulingButtons",
      dayButtonArray: [
        //gregorian calendar
        { name: "Sunday", displayName: "S", value: "1", isActive: false },
        { name: "Monday", displayName: "M", value: "2", isActive: false },
        { name: "Tuesday", displayName: "T", value: "3", isActive: false },
        { name: "Wednesday", displayName: "W", value: "4", isActive: false },
        { name: "Thursday", displayName: "T", value: "5", isActive: false },
        { name: "Friday", displayName: "F", value: "6", isActive: false },
        { name: "Saturday", displayName: "S", value: "7", isActive: false },
      ],
    };
    // this.handleStartDateChange = this.handleStartDateChange.bind(this);
    // this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.detectOnLockDropdownChangeEvent = this.detectOnLockDropdownChangeEvent.bind(
      this
    );
    // this.handleTimedAccess = this.handleTimedAccess.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);
    this.handleFriendsArray = this.handleFriendsArray.bind(this);
    this.onDayButtonClick = this.onDayButtonClick.bind(this);
    this.onSendScheduleAccess = this.onSendScheduleAccess.bind(this);
    this.onTimeStartSelect = this.onTimeStartSelect.bind(this);
    this.onTimeEndSelect = this.onTimeEndSelect.bind(this);
    this.testFunction = this.testFunction.bind(this);
    // this.renderTimepickerInputFormat = this.renderTimepickerInputFormat.bind(this);
  }

  snapshotToArray(snapshot) {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  }

  componentWillMount() {
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        const snapshotVal = snapshot.val();
        // customLog(snapshotVal);
        let lockArrayWithShareRights = [];
        for (const eachLockId in snapshotVal) {
          if (snapshotVal[eachLockId].sharedBy === "") {
            lockArrayWithShareRights.push(snapshotVal[eachLockId]);
          }
        }
        this.setState({
          locklistArray: lockArrayWithShareRights,
          loading: false,
        });
        // }
      })
      .catch((err) => {
        customLog(err);
      });

    // Replacing Axios
    fire
      .database()
      .ref("userFriendListIndustrial")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        let friendListArray = [];
        let friendDetails = {};
        snapshot.forEach((user) => {
          // customLog(user.val());
          const userDetails = user.val();
          const userName = userDetails.friendName;
          const userEmail = userDetails.friendEmail;
          // friendListArray[userName] = userEmail;
          friendDetails = {
            userName: userName,
            userEmail: userEmail,
          };

          friendListArray.push(friendDetails);

          this.setState({
            userFriendListArray: friendListArray,
            loading: false,
          });
        });
        // customLog(friendListArray);
        // this.setState({userFriendListArray : friendListArray});
      })
      .catch((err) => customLog(err));

    //check if members is within the maxUsers limit
    //if it's more than the limit, user will not be able to share any lock
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            // console.log(eachSuperAdmin.val());
            const eachSuperAdminDetails = eachSuperAdmin.val();
            const members = eachSuperAdminDetails.members;

            for (const eachMembers in members) {
              if (members[eachMembers].memberEmail === auth.currentUser.email) {
                const superAdminId = eachSuperAdmin.key;
                const maxUserLimit = eachSuperAdminDetails.payment.maxUsers;
                customLog(superAdminId);
                fire
                  .database()
                  .ref("groupAccounts/" + superAdminId + "/members")
                  .once("value")
                  .then((snapshot) => {
                    const childInDb = snapshot.numChildren();
                    if (childInDb > maxUserLimit) {
                      this.setState({
                        invalidMemberLimit: true,
                      });
                      this.showNotification(
                        "Please delete some members as you have exceeded plan limits",
                        "error",
                        0,
                        false
                      );
                    } else {
                      this.setState({
                        invalidMemberLimit: false,
                      });
                    }
                  });
              }
            }
          });
        }
      });
  } // end of componentWillMount();

  detectOnLockDropdownChangeEvent(event) {
    let targetVal = event.target.value;
    customLog(targetVal);

    if (targetVal !== "null") {
      fire
        .database()
        .ref("userLocks/" + auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            const ssVal = snapshot.val();
            for (const eachLock in ssVal) {
              const lockDetails = ssVal[eachLock];
              const lockName = lockDetails.Name.trim();
              if (targetVal === lockName && lockDetails.sharedBy === "") {
                this.setState({ selectedLock: lockDetails });
                customLog("selectedLock is ", this.state.selectedLock);
              }
            }
          }
        });
    } else {
      this.setState({
        selectedLock: null,
      });
      customLog("selectedLock is NULL");
    }
  }

  renderDropdown() {
    return _.map(this.state.locklistArray, (lockData) => {
      return <option key={lockData.id}>{lockData.Name}</option>;
    });
  }

  handleFriendsArray(selectedFriends) {
    selectedFriends.length > 0
      ? this.setState({ showTable: true })
      : this.setState({ showTable: false });
    // customLog(selectedRecipients.length);
    this.setState({ selectedRecipients: selectedFriends });
  }

  handlewindowShow(event) {
    event.preventDefault();
  }

  onDayButtonClick(index) {
    let dayArray = this.state.dayButtonArray;
    dayArray[index].isActive = !dayArray[index].isActive;
    this.setState({ dayButtonArray: dayArray });
    // if (this.state.dayButtonStyling === "schedulingButtons") {
    //   this.setState({ dayButtonStyling: "schedulingButtonsClicked" })
    // } else {
    //   this.setState({ dayButtonStyling: "schedulingButtons" })
    // }
  }

  async onTimeStartSelect(value) {
    var formattedValue = moment(value).format("HHmm");
    var formattedValueInt = toInteger(formattedValue);
    await this.setState({ selectedStartTime: formattedValueInt });
  }
  async onTimeEndSelect(value) {
    var formattedValue = moment(value).format("HHmm");
    var formattedValueInt = toInteger(formattedValue);
    await this.setState({ selectedEndTime: formattedValueInt });
  }

  async onSendScheduleAccess() {
    customLog(this.state.dayButtonArray);
    customLog(this.state.selectedLock);
    customLog(this.state.selectedRecipients);
    customLog(this.state.selectedStartTime);
    customLog(this.state.selectedEndTime);
    var selectedDaysArray = "";
    this.state.dayButtonArray.forEach((selectedDay) => {
      if (selectedDay.isActive) {
        selectedDaysArray = selectedDaysArray + " " + selectedDay.value;
      }
    });
    customLog(selectedDaysArray);
    await this.testFunction();
    customLog(this.state.selectedTimeRollover);
  }

  testFunction() {
    if (this.state.selectedStartTime > this.state.selectedEndTime) {
      this.setState({
        selectedTimeRollover: true,
      });
    } else if (this.state.selectedStartTime === this.state.selectedEndTime) {
      alert("just send full access lol");
    } else {
      this.setState({
        selectedTimeRollover: false,
      });
    }
  }

  clearForm() {
    this.setState({
      selectedEndTime: 0,
      selectedStartTime: 0,
    });
    document.getElementById("lockSchedulingForm").reset();
  }

  eraseAll() {
    window.location.reload(false);
  }

  render() {
    return (
      <div
        style={{
          maxWidth: "80%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <br />
        <br />
        <form id="lockSchedulingForm" onSubmit={this.handlewindowShow}>
          <FormGroup>
            <div className={"displayBlock"} style={{ display: "flex" }}>
              <div className={"dropDownInput"} style={{ width: "400px" }}>
                <FormControl
                  componentClass="select"
                  className={"grantAccessInput"}
                  onChange={this.detectOnLockDropdownChangeEvent}
                >
                  <option value="null">Please Select a Lock</option>
                  {this.renderDropdown()}
                </FormControl>
              </div>
            </div>
            <div className="thenLine">
              <div className="horizontalLine"></div>
              <p>then</p>
              <div className="horizontalLine"></div>
            </div>
            <div className={"displayBlock"} style={{ display: "flex" }}>
              <div className={"dropDownInput"} style={{ width: "400px" }}>
                <Multiselect
                  containerClassName={"grantAccessMultiSelect"}
                  data={this.state.userFriendListArray}
                  valueField="userEmail"
                  textField="userEmail"
                  onChange={this.handleFriendsArray}
                  placeholder="Please Enter Your Recipients"
                />
              </div>
            </div>
            <br />
            {/* <br /> */}
            <RecipientsTable
              visible={this.state.showTable}
              selectedRecipients={this.state.selectedRecipients}
              // style={{ textAlign: "center"}}
            />
            <br />
            <div>
              <div
                style={{
                  fontSize: "22px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                Please Select Your Day/s
              </div>
              <br />
              <div className="schedulingButtonsWrapper">
                {this.state.dayButtonArray.map((eachButton, index) => (
                  <button
                    key={index}
                    onClick={() => this.onDayButtonClick(index)}
                    className={
                      eachButton.isActive
                        ? "schedulingButtonsClicked"
                        : "schedulingButtons"
                    }
                  >
                    {eachButton.displayName}
                  </button>
                ))}
              </div>
            </div>
            <br />
            <div className="scheduledDateTimeWrapper">
              <div>
                <p>Start Time</p>
                <DateTime
                  dateFormat={false}
                  timeFormat={"HH:mm"}
                  input={false}
                  onChange={this.onTimeStartSelect}
                />
              </div>
              <div>
                <p>End Time</p>
                <DateTime
                  dateFormat={false}
                  timeFormat={"HH:mm"}
                  input={false}
                  onChange={this.onTimeEndSelect}
                />
              </div>
            </div>
            {/* <Row>
              <Button
                className={"clearSendBtn"}
                style={{ width: "100%", marginTop: "20px" }}
                type="reset"
                onClick={this.eraseAll}
              >
                Clear All
              </Button>
            </Row> */}

            <Row>
              <Button
                className="loginsignupbutton"
                style={{ width: "100%", marginTop: "20px" }}
                onClick={this.onSendScheduleAccess}
                disabled={this.state.invalidMemberLimit}
              >
                <strong>
                  {/* {localizationStrings.sendButton} */}
                  Send Scheduled Access
                </strong>
              </Button>
            </Row>
          </FormGroup>
        </form>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(LockScheduling);
